import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { CheckCircle2, Check, ClipboardCopy } from "lucide-react";
import { STATUS_CONFIG } from "../constants";

export function CompletedState({
  applicationStatus,
  isReturned,
  copyLink,
  copied,
  handleReset,
}: {
  applicationStatus: string;
  isReturned: boolean;
  copyLink: () => void;
  copied: boolean;
  handleReset: () => void;
}) {
  const config = STATUS_CONFIG[applicationStatus] ?? STATUS_CONFIG.submitted;

  return (
    <Box textAlign="center" py={20}>
      <Box position="relative" h={24} w={24} mx="auto" mb={8} display="flex" alignItems="center" justifyContent="center" borderRadius="full" bg="green.100">
        <Box position="absolute" inset={0} borderRadius="full" bg="green.500/10" filter="blur(32px)" />
        <CheckCircle2 size={48} color="var(--chakra-colors-green-600)" />
      </Box>
      <Box spaceY={3}>
        <Box display="inline-flex" borderRadius="full" borderWidth="1px" borderColor="green.200" bg="green.50" px={3} py={1}>
          <Text fontSize="xs" fontWeight="semibold" color="green.700" textTransform="uppercase" letterSpacing="wider">
            {config.badge}
          </Text>
        </Box>
        <Text fontSize="4xl" fontWeight="bold" color="gray.900" letterSpacing="tight">
          {config.title}
        </Text>
        <Text fontSize="lg" color="gray.600" maxW="xl" mx="auto">
          {isReturned
            ? "Tus correcciones fueron enviadas exitosamente. El equipo validará los nuevos documentos en breve."
            : config.text}
        </Text>
      </Box>
      <HStack gap={3} mt={10} justifyContent="center" flexWrap="wrap">
        <Button colorPalette="palomma" onClick={copyLink}>
          {copied ? (
            <HStack gap={2}><Check size={18} /> Enlace copiado</HStack>
          ) : (
            <HStack gap={2}><ClipboardCopy size={18} /> Copiar enlace</HStack>
          )}
        </Button>
        <Button variant="outline" onClick={handleReset}>
          Iniciar nueva solicitud
        </Button>
      </HStack>
    </Box>
  );
}
